export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0265.75deb63.jpg";